import classnames from 'classnames';

import './ResendInvitationIcon.css';

interface ResendInvitationIconProps {
  className?: string;
  size?: number;
}

/**
 * Resend invitation icon. Circle uses currentColor; arrow stays white.
 */
function ResendInvitationIcon({ className, size = 24 }: ResendInvitationIconProps) {
  return (
    <svg
      aria-hidden='true'
      className={classnames('resend-invitation-icon', className)}
      fill='none'
      focusable='false'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'>
      <rect
        fill='currentColor'
        height='24'
        rx='12'
        width='24'
      />
      <path
        d='M18.4688 11.5H14.75C14.4375 11.5 14.1562 11.3438 14.0312 11.0625C13.9375 10.7812 14 10.4375 14.2188 10.2188L15.5 8.9375C13.5312 7.03125 10.4062 7.03125 8.4375 8.96875C6.5 10.9375 6.5 14.0938 8.4375 16.0625C10.4062 18 13.5625 18 15.5312 16.0625C15.9062 15.6562 16.5312 15.6562 16.9375 16.0625C17.3125 16.4375 17.3125 17.0625 16.9375 17.4688C14.1875 20.1875 9.78125 20.1875 7.03125 17.4688C4.3125 14.7188 4.3125 10.3125 7.03125 7.5625C9.75 4.84375 14.1562 4.84375 16.9062 7.53125L18.2188 6.21875C18.4062 6.03125 18.75 5.96875 19.0312 6.0625C19.3125 6.1875 19.5 6.46875 19.5 6.75V10.75C19.5 11.1875 19.1562 11.5 18.75 11.5H18.4688Z'
        fill='#ffffff'
      />
    </svg>
  );
}

export default ResendInvitationIcon;
